import { timeZones } from './timezone'

export const availableCurrencies = [
  { symbol: '€', name: 'EUR', region: 'EU', countryCode: 'DE' },
  { symbol: '£', name: 'GBP', region: 'UK', countryCode: 'GB' },
  { symbol: '$', name: 'USD', region: 'US', countryCode: 'US' },
  { symbol: '₹', name: 'INR', region: 'IND', countryCode: 'IN' }
]

// TODO: IND-EXP
export const availableCurrenciesSubset = [
  { symbol: '€', name: 'EUR', region: 'EU' },
  { symbol: '£', name: 'GBP', region: 'UK' },
  { symbol: '$', name: 'USD', region: 'US' }
]

export const getCurrencyNameBySymbol = (symbol) => {
  const currency = availableCurrencies.find((curr) => curr.symbol === symbol)
  return currency ? currency.name : null
}

export const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone

export const getAreaCurrency = (timeZone) => {
  for (const [region, timeZonesForRegion] of Object.entries(timeZones)) {
    if (timeZonesForRegion.includes(timeZone)) {
      const currency = availableCurrencies.find((curr) => curr.region === region)
      return currency ? currency.symbol : '$'
    }
  }
  return '$'
}

export const isIndia = getAreaCurrency(TIMEZONE) === '₹'

export const getCurrencySymbolByCountryCode = (countryCode) => {
  const currency = availableCurrencies.find(
    (curr) => curr.name.toLowerCase() === countryCode?.toLowerCase() || curr.symbol === countryCode
  )
  return currency?.symbol
}

export const getCurrencySymbol = (currencyInput = '$') => {
  const currency = availableCurrencies.find(
    (curr) => curr.name.toLowerCase() === currencyInput?.toLowerCase() || curr.symbol === currencyInput
  )
  return currency?.symbol || '$'
}

export const getPaymentRequestConfigByCurrencySymbol = (currencySymbol = '$') => {
  const currency =
    availableCurrencies.find((curr) => curr.symbol === currencySymbol) ||
    availableCurrencies.find((curr) => curr.symbol === '$')

  return {
    country: currency?.countryCode || 'US',
    currency: currency?.name?.toLowerCase() || 'usd'
  }
}

const CURRENCY_CODE_BY_SYMBOL = { $: 'usd', '€': 'eur', '£': 'gbp', '₹': 'inr' }
const VALID_CURRENCY_CODES = ['usd', 'eur', 'gbp', 'inr']

export const normalizeCurrencyCode = (symbolOrCode) => {
  if (!symbolOrCode) return 'usd'
  const lower = String(symbolOrCode).toLowerCase()
  if (VALID_CURRENCY_CODES.includes(lower)) return lower
  return CURRENCY_CODE_BY_SYMBOL[symbolOrCode] || 'usd'
}
